var map = {
	"./tech-responsive-apache-airflow.svg": 4120,
	"./tech-responsive-artificial-intelligence.svg": 4121,
	"./tech-responsive-azure.svg": 4122,
	"./tech-responsive-chatgpt.svg": 4123,
	"./tech-responsive-copilot.svg": 4124,
	"./tech-responsive-data.svg": 4125,
	"./tech-responsive-excel.svg": 4126,
	"./tech-responsive-git.svg": 4127,
	"./tech-responsive-google-cloud.svg": 4128,
	"./tech-responsive-google-sheets.svg": 4129,
	"./tech-responsive-hugging-face.svg": 4130,
	"./tech-responsive-jupyter.svg": 4131,
	"./tech-responsive-langchain.svg": 4132,
	"./tech-responsive-llama.svg": 4133,
	"./tech-responsive-multiple.svg": 4134,
	"./tech-responsive-powerbi.svg": 4135,
	"./tech-responsive-powerpoint.svg": 4136,
	"./tech-responsive-python.svg": 4137,
	"./tech-responsive-r.svg": 4138,
	"./tech-responsive-shell.svg": 4139,
	"./tech-responsive-sql.svg": 4140,
	"./tech-responsive-tableau.svg": 4141,
	"./tech-responsive-theory.svg": 4142
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3805;